(function () {
    'use strict';

    /*
        1) urls
        2) openIdGrantTypes
        3) openIdScopes
        4) tokenStorageKey
        5) loginStateName
        6) logoutStateName
        7) homeStateName
        8) clubAdminStateName
        9) associationAdminStateName

        10) httpMethods
        11) headerNames
        12) mediaTypes
        13) statusCodes
        14) reasonPhrases
        15) authenticationSchemes
        16) cultureName
        17) keys
        18) passwordOptions
        19) defaultAdminClubIdStorageKey
        20) defaultAdminClubSearchPageSize
        21) mediaStates
        22) adminMode

        100) resources
    */

    var apiRoot = "",
        apiPath = apiRoot + "api/",
        wellKnownPath = apiRoot + '.well-known/',
        openIdPath = apiRoot + 'connect/',
        gettext = angular.identity;

    angular
        .module('app.core')

        // urls
        .constant('urls', {
            // Open Id Connect
            openIdToken: openIdPath + 'token',
            openIdNgnToken: openIdPath + 'ngntoken',
            openIdGeniusToken: openIdPath + 'geniustoken',
            openIdGcrToken: openIdPath + 'gcrtoken',
            openIdImpersonate: openIdPath + 'impersonate',

            // Culture
            languages: '/languages/{{locale}}.json',
            locales: '/lib/angular-i18n/angular-locale_{{locale}}.js',

            // Members
            memberSnapshot: apiPath + 'members/:id/getSnapshot',
            getFriends: apiPath + 'members/:id/getFriends',
            addFriend: apiPath + 'members/:id/addFriend',
            removeFriend: apiPath + 'members/:id/removeFriend',
            memberSearch: apiPath + 'members/search',
            getSettings: apiPath + 'members/:id/getSettings',
            saveSettings: apiPath + 'members/:id/saveSettings',
            changePassword: apiPath + 'members/:id/changePassword',
            saveHomeCourseAndTee: apiPath + 'members/:id/saveHomeCourseAndTee',
            requestCard: apiPath + 'members/:id/requestCard',
            cancelSubscription: apiPath + 'members/:id/cancelSubscription',
            getBadges: apiPath + 'members/:id/getBadges',
            renewOrUpgrade: apiPath + 'members/renewOrUpgrade',
            removeMembers: apiPath + 'members/removeMembers',
            setStatus: apiPath + 'members/setStatus',
            getDetails: apiPath + 'members/:id/getDetails',
            addMember: apiPath + 'members/addMember',
            resetPendingStatus: apiPath + 'members/:id/resetPendingStatus',
            getProfile: apiPath + 'members/:id/getProfile',
            sendPasswordEmail: apiPath + 'members/:id/sendPasswordEmail',
            calculateHandicap: apiPath + 'members/:id/calculateHandicap',
            sendScoresToUSGA: apiPath + 'members/:id/sendScoresToUSGA',
            calculateLowHandicap: apiPath + 'members/:id/calculateLowHandicap',
            reverseActivation: apiPath + 'members/:id/reverseActivation',
            adminSearch: apiPath + 'members/adminSearch',
            saveEmail: apiPath + 'members/:id/saveEmail',
            getIgnMemberships: apiPath + 'members/:id/getIgnMemberships',
            saveIgnMembership: apiPath + 'members/:id/saveIgnMembership',
            deleteIgnMembership: apiPath + 'members/:id/deleteIgnMembership',
            getModifiedHandicap: apiPath + 'members/:id/getModifiedHandicap',
            saveModifiedHandicap: apiPath + 'members/:id/saveModifiedHandicap',
            saveScoreAdjustment: apiPath + 'members/:id/saveScoreAdjustment',

            getIntegrations: apiPath + 'members/:id/getIntegrations',
            saveIntegration: apiPath + 'members/:id/saveIntegration',
            deleteIntegration: apiPath + 'members/:id/deleteIntegration',

            getAttributes: apiPath + 'members/:id/getAttributes',
            saveAttribute: apiPath + 'members/:id/saveAttribute',
            deleteAttribute: apiPath + 'members/:id/deleteAttribute',


            getRoles: apiPath + 'members/:id/getRoles',
            saveRole: apiPath + 'members/:id/saveRole',
            deleteRole: apiPath + 'members/:id/deleteRole',

            getMemberships: apiPath + 'members/:id/getMemberships',
            saveMembership: apiPath + 'members/:id/saveMembership',
            restoreArchivedMembership: apiPath + 'members/:id/restoreArchivedMembership ',

            mergeAccounts: apiPath + 'members/:id/mergeAccounts',
            sendEmail: apiPath + 'members/sendEmail',

            requestTransfer: apiPath + 'members/:id/requestTransfer',
            getCourseList: apiPath + 'members/:id/getCourseList',
            addToCourseList: apiPath + 'members/:id/addToCourseList',
            removeFromCourseList: apiPath + 'members/:id/removeFromCourseList',
            convertNineToEighteen: apiPath + 'members/:id/convertNineToEighteen',

            // crap
            getActivities: apiPath + 'members/:individualId/getActivities',
            saveActivity: apiPath + 'members/:individualId/saveActivity',
            removeActivity: apiPath + 'members/:individualId/removeActivity',
            checkInRBCCanadianOpenPlayer: apiPath + 'members/:id/checkInRBCCanadianOpenPlayer',
            getHandicapHistory: apiPath + 'members/:id/getHandicapHistory',

            // Scores
            score: apiPath + 'scores/:id', // <== currently only works for delete
            scoreHistory: apiPath + 'scores/getHistory',
            getDeletedScores: apiPath + 'scores/getDeletedScores',
            scoreData: apiPath + 'scores/getScoreData',
            postScore: apiPath + 'scores/postScore',
            updateTeeTime: apiPath + 'scores/updateTeeTime',
            getUltimateScorecardFacilities: apiPath + 'scores/getUltimateScorecardFacilities',
            getUltimateScorecard: apiPath + 'scores/getUltimateScorecard',

            getScoringProfile: apiPath + 'scores/getProfile',
            getHandicapCalculation: apiPath + 'scores/getHandicapCalculation',
            getHandicapCard: apiPath + 'scores/getHandicapCard',
            getScoreDetails: apiPath + 'scores/getScoreDetails',

            // Facility
            facilitySearch: apiPath + 'facilities/search',

            // Course
            getCourses: apiPath + 'courses/getCourses',
            getCourseHandicapInfo: apiPath + 'courses/getCourseHandicapInfo',
            searchCourses: apiPath + 'courses/search',

            // Club
            getClubInfo: apiPath + 'clubs/:id/getClubInfo',
            saveClubInfo: apiPath + 'clubs/:id/saveClubInfo',
            getClubStats: apiPath + 'clubs/:id/getClubStats',
            getClubTransactionLog: apiPath + 'clubs/:id/getClubTransactionLog',
            getClubTeeTimeComparisonReport: apiPath + 'clubs/:id/getClubTeeTimeComparisonReport',
            getClubHandicapReview: apiPath + 'clubs/:id/getClubHandicapReview',
            getClubMemberRoster: apiPath + 'clubs/:id/getClubMemberRoster',
            getAdminClubs: apiPath + 'clubs/getAdminClubs',
            getAdminClub: apiPath + 'clubs/getAdminClub',
            adjustMembershipCredits: apiPath + 'clubs/:id/adjustMembershipCredits',
            getClubLevels: apiPath + 'clubs/:id/getClubLevels',           
            getActiveRoster: apiPath + 'clubs/:id/getActiveRoster',

            getSubgroups: apiPath + 'clubs/:id/getSubgroups',
            saveSubgroup: apiPath + 'clubs/:id/saveSubgroup',
            deleteSubgroup: apiPath + 'clubs/:id/deleteSubgroup',
            getSubgroupMembers: apiPath + 'clubs/:id/getSubgroupMembers',
            addSubgroupMember: apiPath + 'clubs/:id/addSubgroupMember',
            removeSubgroupMember: apiPath + 'clubs/:id/removeSubgroupMember',
            searchSubgroupCandidates: apiPath + 'clubs/:id/searchSubgroupCandidates',

            getReports: apiPath + 'clubs/:id/getReports',
            searchClubs: apiPath + 'clubs/searchClubs',

            getTransferList: apiPath + 'clubs/getTransferList',
            acceptTransfer: apiPath + 'clubs/acceptTransfer',
            rejectTransfer: apiPath + 'clubs/rejectTransfer',
            getManagementGroups: apiPath + 'clubs/getManagementGroups',
            getClubContacts: apiPath + 'clubs/:id/getClubContacts',
            saveClubContact: apiPath + 'clubs/:id/saveClubContact',
            deleteClubContact: apiPath + 'clubs/:id/deleteClubContact',
            verifyClubContact: apiPath + 'clubs/:id/verifyClubContact',
            verifyAllClubContacts: apiPath + 'clubs/:id/verifyAllClubContacts',
            getUserClubRoster: apiPath + 'clubs/getUserClubRoster',

            getClubFacility: apiPath + 'clubs/:id/getClubFacility',
            saveClubFacility: apiPath + 'clubs/:id/saveClubFacility',

            // IgnAssociation
            getAllIgnAssociations: apiPath + 'ignAssociations/getAll',

            // Sources
            getAllSources: apiPath + 'sources/getAll',

            // AttributeTypes
            getAllAttributeTypes: apiPath + 'attributes/getAll',

            // Roles
            getAllRoles: apiPath + 'roles/getAll',

            // ManagementGroups
            getAssociationReports: apiPath + 'managementGroups/getReports',
            getAssociationClassicReports: apiPath + 'managementGroups/getClassicReports',
            getAssociationMemberReport: apiPath + 'managementGroups/getMemberReport',
            getAssociationClubComplianceReport: apiPath + 'managementGroups/getClubComplianceReport',
            getAssociationMemberComplianceReport: apiPath + 'managementGroups/getMemberComplianceReport',
            getAssociationMemberReportFields: apiPath + 'managementGroups/getMemberReportFields',
            getManagementGroupsWithAssocation: apiPath + 'managementGroups/getManagementGroups',                   


            // Game Tracker
            getGameTrackerCourses: apiPath + 'gameTracker/getCourses',
            getGameTrackerSummary: apiPath + 'gameTracker/getSummary',
            getScoringStatistics: apiPath + 'gameTracker/getScoringStatistics',
            getGirStatistics: apiPath + 'gameTracker/getGirStatistics',
            getDrivingStatistics: apiPath + 'gameTracker/getDrivingStatistics',
            getPuttingStatistics: apiPath + 'gameTracker/getPuttingStatistics',
            getRecoveryStatistics: apiPath + 'gameTracker/getRecoveryStatistics',
            getParStatistics: apiPath + 'gameTracker/getParStatistics',

            // PasswordReset
            resetPassword: apiPath + 'passwordReset/resetPassword',
            resolveToken: apiPath + 'passwordReset/resolveToken',
            sendPasswordResetEmail: apiPath + 'passwordReset/sendPasswordResetEmail',

            // Survey
            getSurveyQuestion: apiPath + 'survey/getQuestion',
            saveSurveyQuestion: apiPath + 'survey/saveQuestion'
        })

        // openIdGrantTypes
        .constant('openIdGrantTypes', {
            authorizationCode: "authorization_code",
            clientCredentials: "client_credentials",
            implicit: "implicit",
            password: "password",
            refreshToken: "refresh_token",
            // custom grant types
            guid: "guid",
            hash: "hash"
        })

        // openIdScopes
        .constant('openIdScopes', {
            address: "address",
            email: "email",
            offlineAccess: "offline_access",
            openId: "openid",
            phone: "phone",
            profile: "profile",
            roles: "roles",
        })

        // tokenStorageKey
        .constant('tokenStorageKey', 'token')

        // loginStateName
        .constant('loginStateName', 'login')

        // logoutStateName
        .constant('logoutStateName', 'logout')

        // homeStateName
        .constant('homeStateName', 'home')

        // clubAdminStateName
        .constant('clubAdminStateName', 'club-admin')

        // associationAdminStateName
        .constant('associationAdminStateName', 'association-admin')

        // httpMethods
        .constant('httpMethods', {
            connect: "CONNECT",
            delete: "DELETE",
            get: "GET",
            head: "HEAD",
            options: "OPTIONS",
            patch: "PATCH",
            post: "POST",
            put: "PUT",
            trace: "TRACE",
        })

        // headerNames
        .constant('headerNames', {
            accept: "Accept",
            acceptCharset: "Accept-Charset",
            acceptEncoding: "Accept-Encoding",
            acceptLanguage: "Accept-Language",
            acceptRanges: "Accept-Ranges",
            age: "Age",
            allow: "Allow",
            authorization: "Authorization",
            cacheControl: "Cache-Control",
            connection: "Connection",
            contentDisposition: "Content-Disposition",
            contentEncoding: "Content-Encoding",
            contentLanguage: "Content-Language",
            contentLength: "Content-Length",
            contentLocation: "Content-Location",
            contentMD5: "ContentMD5",
            contentRange: "Content-Range",
            contentType: "Content-Type",
            cookie: "Cookie",
            date: "Date",
            eTag: "ETag",
            expires: "Expires",
            expect: "Expect",
            from: "From",
            host: "Host",
            ifMatch: "If-Match",
            ifModifiedSince: "If-Modified-Since",
            ifNoneMatch: "If-None-Match",
            ifRange: "If-Range",
            ifUnmodifiedSince: "If-Unmodified-Since",
            lastModified: "Last-Modified",
            location: "Location",
            maxForwards: "Max-Forwards",
            pragma: "Pragma",
            proxyAuthenticate: "Proxy-Authenticate",
            proxyAuthorization: "Proxy-Authorization",
            range: "Range",
            referer: "Referer",
            requestWith: "X-Requested-With",
            retryAfter: "Retry-After",
            server: "Server",
            setCookie: "Set-Cookie",
            te: "TE",
            trailer: "Trailer",
            transferEncoding: "Transfer-Encoding",
            upgrade: "Upgrade",
            userAgent: "User-Agent",
            vary: "Vary",
            via: "Via",
            warning: "Warning",
            webSocketSubProtocols: "Sec-WebSocket-Protocol",
            wwwAuthenticate: "WWW-Authenticate"
        })

        // mediaTypes
        .constant('mediaTypes', {
            // Common
            applicationXml: 'application/xml',
            applicationJson: 'application/json',
            applicationOctetStream: 'application/octet-stream',
            applicationFormUrlEncoded: 'application/x-www-form-urlencoded',
            applicationBson: 'application/bson',

            // Images
            imageJpeg: 'image/jpeg',
            imagePng: 'image/png',
            imageBmp: 'image/bmp',
            imageGif: 'image/gif',
            imageTiff: 'image/tiff',
            imageIcon: 'image/x-icon',

            // Videos
            videoMp4: "video/mp4",
            videoWmv: "video/x-ms-wmv",
            videoFlv: "video/x-flv",
            videoAvi: 'video/x-msvideo',
            videoMov: 'video/quicktime',
        })

        // statusCodes
        .constant('statusCodes', {
            switchingProtocols: 101,

            ok: 200,
            created: 201,
            accepted: 202,
            nonAuthoritative: 203,
            noContent: 204,
            resetContent: 205,
            partialContent: 206,
            multiStatus: 207,

            multipleChoices: 300,
            movedPermanently: 301,
            found: 302,
            seeOther: 303,
            notModified: 304,
            useProxy: 305,
            switchProxy: 306,
            temporaryRedirect: 307,
            permanentRedirect: 308,

            badRequest: 400,
            unauthorized: 401,
            paymentRequired: 402,
            forbidden: 403,
            notFound: 404,
            methodNotAllowed: 405,
            notAcceptable: 406,
            proxyAuthenticationRequired: 407,
            requestTimeout: 408,
            conflict: 409,
            gone: 410,
            lengthRequired: 411,
            preconditionFailed: 412,
            requestEntityTooLarge: 413,
            requestUriTooLong: 414,
            unsupportedMediaType: 415,
            requestedRangeNotSatisfiable: 416,
            expectationFailed: 417,
            imATeapot: 418,
            authenticationTimeout: 419,
            unprocessableEntity: 422,
            locked: 423,
            failedDependency: 424,
            unavailableForLegalReasons: 451,

            internalServerError: 500,
            notImplemented: 501,
            badGateway: 502,
            serviceUnavailable: 503,
            gatewayTimeout: 504,
            httpVersionNotsupported: 505,
            variantAlsoNegotiates: 506,
            insufficientStorage: 507,

        })

        // reasonPhrases 
        .constant('reasonPhrases', {
            101: 'Switching Protocols',

            200: 'OK',
            201: 'Created',
            202: 'Accepted',
            203: 'Non-Authoritative Information',
            204: 'No Content',
            205: 'Reset Content',
            206: 'Partial Content',

            300: 'Multiple Choices',
            301: 'Moved Permanently',
            302: 'Found',
            303: 'See Other',
            304: 'Not Modified',
            305: 'Use Proxy',
            306: 'Switch Proxy',
            307: 'Temporary Redirect',

            400: 'Bad Request',
            401: 'Unauthorized',
            402: 'Payment Required',
            403: 'Forbidden',
            404: 'Not Found',
            405: 'Method Not Allowed',
            406: 'Not Acceptable',
            407: 'Proxy Authentication Required',
            408: 'Request Timeout',
            409: 'Conflict',
            410: 'Gone',
            411: 'Length Required',
            412: 'Precondition Failed',
            413: 'Request Entity Too Large',
            414: 'Request-URI Too Long',
            415: 'Unsupported Media Type',
            416: 'Requested Range Not Satisfiable',
            417: 'Expectation Failed',
            418: 'I\'m a teapot',
            419: 'Authentication Timeout',

            500: 'Internal Server Error',
            501: 'Not Implemented',
            502: 'Bad Gateway',
            503: 'Service Unavailable',
            504: 'Gateway Timeout',
            505: 'HTTP Version Not Supported',
            506: 'Variant Also Negotiates'
        })

        // authenticationSchemes
        .constant('authenticationSchemes', {
            basic: 'Basic',
            bearer: 'Bearer',
            digest: 'Digest'
        })

        // cultureName
        .enumeration('cultureName', {
            en: ['en', gettext('English'), gettext('English')],
            en_US: ['en-US', gettext('English - United States'), gettext('English')],
            en_CA: ['en-CA', gettext('English - Canada'), gettext('English')],
            fr: ['fr', gettext('French'), gettext('French')],
            fr_CA: ['fr-CA', gettext('French - Canada'), gettext('French')]
        })

        // keys
        .constant('keys', {
            INSERT: 45,
            DELETE: 46,
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            ESC: 27,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            END: 35,
            HOME: 36,
            SPACEBAR: 32,
            PAGEUP: 33,
            PAGEDOWN: 34,
            F2: 113,
            F10: 121,
            F12: 123,
            NUMPAD_PLUS: 107,
            NUMPAD_MINUS: 109,
            NUMPAD_DOT: 110
        })

        // passwordOptions
        .constant('passwordOptions', {
            requiredLength: 6,
            requireNonAlphanumeric: false,
            requireLowercase: false,
            requireUppercase: false,
            requireDigit: false
        })

        // defaultAdminClubIdStorageKey
        .constant('defaultAdminClubIdStorageKey', 'defaultAdminClubId')

        // defaultAdminClubSearchPageSize
        .constant('defaultAdminClubSearchPageSize', 10)

        // mediaStates
        .enumeration('mediaStates', {
            xs: { value: 'xs', queryString: '(max-width: 767px)' },
            sm: { value: 'sm', queryString: '(min-width: 768px) and (max-width: 991px)' },
            md: { value: 'md', queryString: '(min-width: 992px) and (max-width: 1199px)' },
            lg: { value: 'lg', queryString: '(min-width: 1200px)' }
        })

        // adminMode
        .enumeration('adminMode', {
            Association: 1,
            Club: 2
        })

        // resources
        .constant('core_resources', {
            userNotLoggedIn: gettext('User is not logged in.'),
            failedToLoadLanguage: 'Failed to load language \'{0}\'.',
            removeFriendConfirmation: gettext('Are you sure you want to remove {0} from your favorite players?'),
            removeFriendError: gettext('Unable to remove {0} from your favorite players.'),
            addFriendError: gettext('Unable to add {0} to your favorite players.'),
            toggleFriendArgumentError: gettext('The member parameter must be an object with "individualId", "name", and "isFriend" properties.'),
            adminClubLookupDataFailed: gettext('Failed to initialize admin club lookup.'),
        });
})();